export const ADMINISTRATIVE_LEAVES_COMBOS_IDS = ['cod_zona_zeus']
